import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { getClientId, setTokens } from '~/services/auth';
import { IThunkVerifyCode } from '../types';

const onVerifyCode: IThunkVerifyCode = thunk(
  // @ts-ignore
  async ({ resetMfa, setAuthorized }, payload) => {
    const clientId = getClientId();

    const data = await api.auth
      .verifyCode({
        ...payload,
        clientId,
      })
      .then(response => response.data);

    setTokens(data);

    setAuthorized();
    resetMfa();
  },
);

export default onVerifyCode;
